import { render, staticRenderFns } from "./NewWaybillExit.vue?vue&type=template&id=af99a37e&scoped=true&"
import script from "./NewWaybillExit.vue?vue&type=script&lang=js&"
export * from "./NewWaybillExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af99a37e",
  null
  
)

export default component.exports